module.exports = __webpack_public_path__ + "img/bg1.d70f75de.png";